import {useEffect, useState} from "react"
import {ProfileDB} from "../models/ProfileDB.model"

export function useUserID(profile?: ProfileDB) {
  const [userID, setUserID] = useState<string>()

  useEffect(() => {
    if (!profile) {
      return
    }
    const address = profile.address
    const orbitId = address.root
    const pubKey = address.path
    const webIdentity = profile.get("webIdentity") ?? ""
    const desktopIdentity = profile.get("desktopIdentity") ?? ""
    const userID = `${webIdentity}-${desktopIdentity}-${orbitId}-${pubKey}`
    setUserID(userID)
  }, [profile])

  return {
    userID
  }
}
